import { assetPrefix } from 'src/config/env_config'
import { getServiceIconByName } from 'src/utils'

export const ICONS = {
  service: (serviceName) => getServiceIconByName(serviceName, 'outline'),
  pet: `${assetPrefix}/static/icons/pet-outline.svg`,
  location: `${assetPrefix}/static/icons/location-outline.svg`,
  phone: `${assetPrefix}/static/icons/phone-alt.svg`,
  professional: `${assetPrefix}/static/icons/avatar-outline.svg`,
  payment: `${assetPrefix}/static/icons/payment-outline.svg`,
  obs: `${assetPrefix}/static/icons/obs-outline.svg`,
  campaign: `${assetPrefix}/static/icons/campaign-outline.svg`,
  coupon: `${assetPrefix}/static/icons/coupon-outline.svg`
}

export const PARTNER_INFO = (partner) => {
  return {
    name: partner.split('-')[0].trim(),
    address: partner.split('-')[1].trim()
  }
}
